/* eslint-disable  */
//@ts-nocheck

'use strict';

import React from 'react';
import ReactDOM from 'react-dom';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
class Autocomplete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuVisible: false,
      options: [],
    };
    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onOptionClick = this.onOptionClick.bind(this);
    this.searchAPIDebounced = AwesomeDebouncePromise(
      this.props.getOptions,
      400,
    );
  }
  onChange(ev) {
    if (
      ev &&
      ev.target &&
      ev.target.value &&
      ev.target.value.length &&
      ev.target.value.length < 3
    ) {
      this.props.onChange({ name: ev.target.value });
      this.setState({ options: [], menuVisible: false });
      return;
    }
    //console.log('[Autocomplete] onChange() called.', ev.target.value);
    this.props.onChange({ name: ev.target.value });
    this.searchAPIDebounced(ev.target.value)
      .then((options) => {
        //console.log('[Autocomplete] Fetched options.', options);
        this.setState({ options, menuVisible: true });
      })
      .catch((e) => {
        console.log('[Autocomplete] Error fetching autocomplete options.', e);
        this.setState({ menuVisible: false });
      });
  }
  onBlur() {
    //console.log('[Autocomplete] Blur is happening.');
    setTimeout(() => this.setState({ menuVisible: false }), 300);
  }
  componentDidMount() {
    //console.log('[Autocomplete] Adding document click & tap listener.');
    document.addEventListener('click', this.onDocumentClick, true);
    document.addEventListener('touchstart', this.onDocumentClick, true);
  }
  componentWillUnmount() {
    //console.log('[Autocomplete] Removing document click & tap listener.');
    document.removeEventListener('click', this.onDocumentClick, true);
    document.removeEventListener('touchstart', this.onDocumentClick, true);
  }
  onDocumentClick(e) {
    // https://github.com/kentor/react-click-outside/blob/master/dist/index.js
    var domNode = ReactDOM.findDOMNode(this);
    if (!domNode || !domNode.contains(e.target)) {
      this.setState({ menuVisible: false });
    }
  }
  onOptionClick(value) {
    //console.log('[Autocomplete] user selected value', value);
    this.props.onChange(value);
    this.setState({ menuVisible: false });
  }
  render() {
    //console.log('[Autocomplete] render() called.');
    let options = '';
    if (
      this.props.value &&
      this.props.value.length > 3 &&
      this.state.menuVisible &&
      this.state.options &&
      this.state.options.length > 0
    ) {
      let items = this.state.options.map((o, i) => (
        <li
          key={i}
          onClick={() => (o && o.name ? this.onOptionClick(o) : null)}
        >
          {o.name}
        </li>
      )); // kek
      options = <ul>{items}</ul>;
    }

    return (
      <div className="autocomplete">
        <input
          value={this.props.value}
          onChange={this.onChange}
          placeholder={this.props.placeholder}
          onBlur={this.onBlur}
          maxLength={this.props.maxLength}
          className={this.props.className}
        />
        {options}
      </div>
    );
  }
}

export default Autocomplete;
